import { CompanyIntegrationsModel }     from '../../app-lite/companies/models/company.integrations';
import { AssemblyPaymentsService }      from './assembly-payments.service.ajs';
import { AssemblyPaymentTerminalModel } from './models/assembly-payment.terminal';

interface AssemblyPaymentsSettingsScope extends ng.IScope {
  activate       : () => void;
  deactivate     : () => void;
  form           : ng.IFormController;
  getPosName     : () => string;
  integrations   : CompanyIntegrationsModel;
  loaded         : boolean;
  save           : () => void;
  switchTestMode : () => void;
  terminal       : AssemblyPaymentTerminalModel;
  terminals      : Array<AssemblyPaymentTerminalModel>;
};

export function AssemblyPaymentsSettingsCtrl (
  $state             : ng.ui.IStateService,
  $scope             : AssemblyPaymentsSettingsScope,
  $translate         : ng.translate.ITranslateService,
  assemblyPaymentsApi: AssemblyPaymentsService,
  integrations       : CompanyIntegrationsModel,
  messages           : any,
  terminals          : Array<AssemblyPaymentTerminalModel>
) {

  $scope.integrations  = integrations;
  $scope.loaded        = true;
  $scope.terminals     = terminals;

  $scope.terminal = {
    ap_ip_address   : null,
    ap_pos_id       : null,
    ap_serial_number: null
  };

  $scope.activate = function () {
    assemblyPaymentsApi.activate($scope.terminal)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', { name: $scope.getPosName() }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.deactivate = function () {
    assemblyPaymentsApi.deactivate($scope.terminal)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', { name: $scope.getPosName() }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.getPosName = function () {
    return assemblyPaymentsApi.getPosName($scope.terminal);
  };

  $scope.save = function ( form = $scope.form ) {
    assemblyPaymentsApi.saveTerminal($scope.terminal)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      form.$setPristine();

      $state.reload();
    })
    .catch(data => {
      messages.error(data);
    });
  };

  $scope.switchTestMode = function () {
    assemblyPaymentsApi.saveTestMode($scope.integrations)
    .then(result => result.ap_use_test_mode
      ? messages.show($translate.instant('ASSEMBLY_PAYMENTS_SPACE.TEST_MODE_ON'), 'success')
      : messages.show($translate.instant('ASSEMBLY_PAYMENTS_SPACE.TEST_MODE_OFF'), 'success')
    );
  };
};
